var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJkVPuAgn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#22BF76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7614 13.5979C17.5586 12.8007 18.9536 12.8007 19.7507 13.5979L24.5336 18.3808C25.3308 19.0783 25.3308 20.274 24.5336 20.9715L22.0425 23.5622C23.5372 26.3522 24.8326 28.1458 26.7258 29.9394C28.4197 31.6333 30.313 32.7294 32.6048 34.0248L35.0958 31.5337C35.893 30.7366 36.9891 30.7366 37.7862 31.5337L42.5691 36.3166C43.3663 37.1137 43.3663 38.4091 42.5691 39.3059C41.8716 40.0034 41.0745 40.7009 40.377 41.4981C32.4055 49.6688 6.39849 23.7615 14.5693 15.79C15.3664 14.9929 16.0639 14.2954 16.7614 13.5979Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJkVPuAgn);
export default __webpack_public_path__ + "static/media/jkVPuAgn.81d5223c45766e999aa3ad04fd829993.svg";
export { ForwardRef as ReactComponent };